import { render } from "./ParticipantForm.vue?vue&type=template&id=2226e33d&scoped=true"
import script from "./ParticipantForm.vue?vue&type=script&lang=js"
export * from "./ParticipantForm.vue?vue&type=script&lang=js"

import "./ParticipantForm.vue?vue&type=style&index=0&id=2226e33d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2226e33d"]])

export default __exports__